export const questionListEN = [
    {
        id: 0,
        question: "How to Log in e-FormSS?",
        answer: [
            {
                number: 1,
                description: "Common Log-On System (CLO) Login Method: Common Log-On System (CLO) users have two options for logging in: ",
                description0: " 1. Through the ",
                description6: "2. Directly via the e-FormSS ",
                CLOEfomssHyperlink: "cloportallogin",
                SSLOEfomssHyperlink: "loginSSLO",
                PublicEfomssHyperlink: "loginPublic",
                link: "link",
                clo: "CLO",
                dot: ".",
                CLOHyperlink: "https://clo.edb.gov.hk",          
                description3: "SSLO Login Method: SSLO users can log in directly using the e-FormSS ",
                description4: "Public Login Method: The public can log in directly using the e-FormSS ",
                description5:" They have the option to use their email address or “iAM Smart” for authentication.",
                multiple : "3",
            }
        ]
    },


    {
        id: 1,
        question: "Which login method should I use: CLO, SSLO or Public? ",
        answer: [
            {
                number: 1,
                description: "Common Log-On System (CLO)  Login Method: For individuals such as teachers, School Heads and School Supervisors. To log in, they must have e-Services account, Common Log-On System (CLO) account or Training Calendar System (TCS) account.",

                description3: "SSLO Login Method: For NGO with SSLO accounts.",

                description4: "Public Login Method: For the General Public.",
                multiple : "3"
            }
        ]
    },

    {
        id: 2,
        question: "Is there any limit on the file size or requirement on the file types accepted for attachments for e-form submission?",
        answer: [
            {
                number: 1,
                description: "Yes, the requirements for each form may vary. Please review the instructions corresponding to the specific form."
            }
        ]
    },

    {
        id: 3,
        question: "What are the signing methods supported?",
        answer: [
            {
                number: 1,
                title: "There are three signing methods supported:\n",
                description: "Digital Signing.",

                description3: "Uploading Signature image file (acceptable attachment types: jpg, jpeg, png; size up to 3MB and file name must not exceed 70 characters).",

                multiple : "3",
                description4: "\"iAM Smart+\" (some forms only accept this method)."
            },
        ]
    },

    {
        id: 4,
        question: "Why am I not able to see the form I want to fill in?",
        answer: [
            {
                number: 1,
                description: "Certain forms may only be accessible by specific groups (Public / CLO / SSLO). If you do not belong to the designated group, you may not be able to see the form. Please contact the account holders with administration rights (e.g. School Heads, Master School Administrators (MSAs) , CLO School Administrators (CSAs) , etc.) of your School/Organisation for them to delegate the form to you on e-FormSS delegation page."
            }
        ]
    },

    {
        id: 5,
        question: "Can the same form be re-submitted if it has been rejected?",
        answer: [
            {
                number: 1,
                description: "No, after the form is rejected, it cannot be submitted again. If the form is rejected, you can only start over with a new form. Nevertheless, if the form has only been returned by other parties, you can edit the form and submit it again."
            }
        ]
    },
    
    {
        id: 6,
        question: "How to delegate a form?",
        answer: [
            {
                number: 1,
                description: "The delegate permission is available only to admin, School Head, and School Supervisor. The delegate feature is accessible in the menu bar under “delegate page.”"
            }
        ]
    },

    {
        id: 7,
        question: "Why am I not able to delegate the form to my colleagues?",
        answer: [
            {
                number: 1,
                description: "It is possible that the form is restricted to specific positions or your colleagues are not in the same school or organisation as you."
            }
        ]
    },

    {
        id: 8,
        question: "How can I check the form status?",
        answer: [
            {
                number: 1,
                description: "Log in to e-FormSS and click on “Search Application.”"
            }
        ]
    },

    {
        id: 9,
        question: " How to check the form reference number?",
        answer: [
            {
                number: 1,
                description: "The form reference number is displayed in the notification email and can also be found in the e-FormSS “Search Application” section."
            }
        ]
    },

    {
        id: 10,
        question: " I work in school, but why am I not able to update my personal information in e-FormSS?",
        answer: [
            {
                number: 1,
                description: "The personal data stored in e-FormSS is retrieved from e-Services, Common Log-On System (CLO) or Training Calendar System (TCS).  Users may have to log on to these systems to update their personal information."
            }
        ]
    },

    {
        id: 11,
        question: " Why are Master School Administrators (MSAs) or CLO School Administrators (CSAs) not able to add, edit or delete staff information?",
        answer: [
            {
                number: 1,
                description: "The data is provided by e-Services, Common Log-On System (CLO) or Training Calendar System (TCS). Users may have to log on to these systems to update the relevant data."
            }
        ]
    },

    {
        id: 12,
        question: " How to update the personal information for Public / Organisation user in e-FormSS?",
        answer: [
            {
                number: 1,
                description: "Users may update the relevant information on profile page after logging on to e-FormSS."
            }
        ]
    },

    {
        id: 13,
        question: " How to delete the administrator account in an organisation?",
        answer: [
            {
                number: 1,
                description: "Administrator account can delete other administrator account when the organisation has more than 1 administrator account."
            }
        ]
    },

    {
        id: 14,
        question: " How can I modify the default applicants or approvers of all forms at once?",
        answer: [
            {
                number: 1,
                description: "The current system does not support this function. Users are required to select the applicant or approver for each form individually."
            }
        ]
    },

    {
        id: 15,
        question: " After the applicant submits the form, why does the approver fail to receive the form?",
        answer: [
            {
                number: 1,
                description: "When the designator assigns the form, the approver’s account should match the account selected by the designator. For example, if the approver is usually the principal’s personal account, he can only receive the form when he logs in the system with his/her personal account."
            }
        ]
    },

    {
        id: 16,
        question: " What should I do if I have questions about filling out a form?",
        answer: [
            {
                number: 1,
                description: "Users can go to the left side of the e-FormSS homepage, select “e-Forms Application” and then fill in the name of the form. Click the ",
                imageSrc: "1",
                description2:"   icon on the right side of the form name for the enquiry phone number related to the form to get assistance."
            }
        ]
    },

    {
        id: 17,
        question: " Why am I not able to find the approver’s account when making a delegation?",
        answer: [
            {
                number: 1,
                description: "The designator may not find the account of the applicant or approver if it is a new account created in e-Services, Common Log-On System (CLO) or Training Calendar System (TCS). In such cases, the designator needs to wait 1-2 days for the new account to take effect."
            }
        ]
    },
    {
        id: 18,
        question: " Is it possible to change the approver of all submitted forms in one go?",
        answer: [
            {
                number: 1,
                description: "No. Master School Administrators (MSAs), CLO School Administrators (CSAs), School Supervisor, School Head or Head of Organisation have to modify each form on the delegation page. Alternatively, the original approver can delegate to the new approver in the form."
            }
        ]
    },
    {
        id: 19,
        question: " Why I am not able to find the form on the delegation page?",
        answer: [
            {
                number: 1,
                description: "If the form does not exist on the delegation page, please contact the e-FormSS support hotline for further assistance."
            }
        ]
    },
    {
        id: 20,
        question: " What should I do if I have submitted the wrong form?",
        answer: [
            {
                number: 1,
                description: "Please refer to the information about the application / forms and contact the relevant Section of the EDB."
            }
        ]
    },
    
];


